import { render, staticRenderFns } from "./core-event-fee-description-modal.vue?vue&type=template&id=223a2418&scoped=true"
import script from "./core-event-fee-description-modal.vue?vue&type=script&lang=js"
export * from "./core-event-fee-description-modal.vue?vue&type=script&lang=js"
import style0 from "./core-event-fee-description-modal.vue?vue&type=style&index=0&id=223a2418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a2418",
  null
  
)

export default component.exports